import { totalMessagesSentGauge } from 'ducks/reports/gauges/definitions/totalMessagesSentGauge'
import { HeadlineVisualization } from 'ducks/reports/visualizations'

const staticProps = {
  gauges: [totalMessagesSentGauge],
}
export default function TotalMessagesSentHeadline(props) {
  return <HeadlineVisualization {...props} {...staticProps} />
}
